import { render, staticRenderFns } from "./PlansFAQ.vue?vue&type=template&id=72172abe&scoped=true"
import script from "./PlansFAQ.vue?vue&type=script&lang=js"
export * from "./PlansFAQ.vue?vue&type=script&lang=js"
import style0 from "./PlansFAQ.vue?vue&type=style&index=0&id=72172abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72172abe",
  null
  
)

export default component.exports